import React, { useContext } from 'react'
import { StyledFooter } from './Footer.styled'
import Button from '../Button'
import useNextPage from '../../hooks/useNextPage'
import { courseStore } from '../../state/courseStore'
import { pageStore } from '../../state/pagestore'
const Footer = ({ nextPage, onLastPage, levelID, levelNumber, allowSkip, link }) => {
  const [handleNextPage] = useNextPage({ levelID, nextPage, onLastPage, link })
  const { state: courseState } = useContext(courseStore)
  const { state: pageState } = useContext(pageStore)
  return (
    <StyledFooter>
      {!allowSkip && <Button text='continueLabel' classes={['continue']} handleClick={handleNextPage} />}
      {allowSkip && courseState.allowSkip && pageState.allowSkip && <Button text='skipLabel' classes={['skip']} handleClick={handleNextPage} />}
    </StyledFooter>
  )
}

export default Footer
